(function($, window, document) {
	
	// Page Functions
	
	var canBeLoaded = true;

	window.PageFunctions = {
		
		setup: function() {
			this.initAos();
		},

		initAos: function() {
              AOS.init();
		}

	};

})(window.jQuery, window, document); // End of jQuery wrapper



